<template>
  <div>
    <h1 class="capitalize">{{ t('importStepper.importMapper') }}</h1>
    <ImportMapper :quotation-id="id"></ImportMapper>
  </div>
</template>

<script setup lang="ts">
import ImportMapper from '@/domains/quotations/mapper/ImportMapper.vue'
import { useI18n } from 'vue-i18n'

definePage({
  props: true
})
const { id } = defineProps<{ id: string }>()
const { t } = useI18n()
</script>
